import {
    SEARCH_QUERY_CHANGED,
    FETCH_SEARCH_RESULTS_REQUEST,
    FETCH_SEARCH_RESULTS_SUCCESSFUL,
    FETCH_SEARCH_RESULTS_ERROR,
    LOAD_MORE_SEARCH_RESULTS_REQUEST,
    LOAD_MORE_SEARCH_RESULTS_SUCCESSFUL,
    LOAD_MORE_SEARCH_RESULTS_ERROR,
    TOGGLE_SEARCH_DIALOG
} from '../actions'

const initialState = {
    open: false,
    page: 1,
    page_size: 8,
    total_results: 0,
    total_pages: 0,
    query: '',
    tags: [],
    categories: [],
    gender: [],
    loading: false,
    results: [],
    error: undefined,
}

const search = (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE_SEARCH_DIALOG: {
            return {
                ...state,
                open: !state.open
            }
        }
        case SEARCH_QUERY_CHANGED: {
            return {
                ...state,
                query: action.payload.query,
                tags: action.payload.tags,
                categories: action.payload.categories,
                gender: action.payload.gender,
                loading: true
            }
        }
        case FETCH_SEARCH_RESULTS_REQUEST:
            return {
                ...state,
                query: action.payload.query,
                tags: action.payload.tags,
                categories: action.payload.categories,
                gender: action.payload.gender,
                page: 1,
                page_size: action.payload.page_size,
                loading: true
            }
        case FETCH_SEARCH_RESULTS_SUCCESSFUL:
            return {
                ...state,
                results: action.payload.results,
                total_results: action.payload.total_results_size,
                total_pages: action.payload.total_pages,
                loading: false
            }
        case FETCH_SEARCH_RESULTS_ERROR:
        case LOAD_MORE_SEARCH_RESULTS_ERROR:
            return {
                ...state,
                loading: false,
                error: {message: "Error loading articles"},
            }
        case LOAD_MORE_SEARCH_RESULTS_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case LOAD_MORE_SEARCH_RESULTS_SUCCESSFUL:
            return {
                ...state,
                results: [
                    ...state.results,
                    ...action.payload.results,
                ],
                page: action.payload.page,
                page_size: action.payload.page_size,
                total_results: action.payload.total_results_size,
                total_pages: action.payload.total_pages,
                loading: false
            }

        default:
            return state
    }
}

export default search



// WEBPACK FOOTER //
// ./src/reducers/search.js